// JS for subscription/one-time plan selection

document.addEventListener('DOMContentLoaded', function () {
  // Tab switching for .frequency-tab
  document.querySelectorAll('.frequency-tab').forEach(function(tabBlock) {
    tabBlock.addEventListener('click', function() {
      // Remove 'active' from all .subscr-plan
      document.querySelectorAll('.subscr-plan.active').forEach(function(el) {
        el.classList.remove('active');
      });
      // Remove 'active' from all .frequency-tab
      document.querySelectorAll('.frequency-tab.active').forEach(function(el) {
        el.classList.remove('active');
      });
      // Add 'active' to clicked tab
      tabBlock.classList.add('active');
      // Activate corresponding .frequency-tab-content by data-tab/data-content
      var tabValue = tabBlock.getAttribute('data-tab');
      if (tabValue) {
        document.querySelectorAll('.frequency-tab-content').forEach(function(contentBlock) {
          if (contentBlock.getAttribute('data-content') === tabValue) {
            contentBlock.classList.add('active');
            // Click first .subscr-plan inside new active tab-content
            var firstPlan = contentBlock.querySelector('.subscr-plan');
            if (firstPlan) firstPlan.click();
          } else {
            contentBlock.classList.remove('active');
          }
        });
      }
    });
  });

  // Helper function to set AddToCart button text
  function setAddToCartText(isAvailable, splanprice) {
    var btn = document.querySelector('#AddToCart .loader-button__text') || document.getElementById('AddToCart');
    if (!btn) return;
    if (isAvailable === 'true') {
      btn.innerHTML = (typeof btnTextaddtocart !== 'undefined' ? btnTextaddtocart : 'Add to cart') + '&nbsp;-&nbsp;' + splanprice;
    } else {
      btn.innerHTML = (typeof btnTextsold !== 'undefined' ? btnTextsold : 'Sold out') + '&nbsp;-&nbsp;' + splanprice;
    }
  }

  // Click handler for all .subscr-plan blocks
  document.querySelectorAll('.subscr-plan').forEach(function(planBlock) {
    planBlock.addEventListener('click', function() {
      // 1. Remove 'active' from all, add to clicked
      document.querySelectorAll('.subscr-plan.active').forEach(function(el) {
        el.classList.remove('active');
      });
      this.classList.add('active');

      var splanid = this.getAttribute('splanid');
      var varid = this.getAttribute('varid');
      var available = this.getAttribute('available');
      var splanprice = this.getAttribute('splanprice');
      var variantSelect = document.getElementById('variant_select');
      var sellingPlanInput = document.getElementById('selling-plan-input');

      if (splanid) {
        // Find option with data-sellingplanid == splanid
        if (variantSelect) {
          var found = false;
          Array.from(variantSelect.options).forEach(function(opt) {
            if (opt.getAttribute('data-sellingplanid') === splanid) {
              variantSelect.value = opt.value;
              found = true;
            }
          });
          if (!found) {
            // fallback: do nothing
          }
        }
        if (sellingPlanInput) sellingPlanInput.value = splanid;
      } else if (varid) {
        // Find option with value == varid
        if (variantSelect) {
          Array.from(variantSelect.options).forEach(function(opt) {
            if (opt.value === varid) {
              variantSelect.value = varid;
            }
          });
        }
        if (sellingPlanInput) sellingPlanInput.value = '';
      }

      // Update AddToCart button text
      setAddToCartText(available, splanprice);
    });
  });
});
